<div class="minha-agenda-container">
  <h1>Minha Agenda</h1>
  <div class="app-calendar" *ngIf="calendarVisible">
    <full-calendar
      #calendar
      defaultView="dayGridMonth"
      [header]="{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      }"
      [plugins]="calendarPlugins"
      [weekends]="calendarWeekends"
      [events]="calendarEvents"
      [locale]="locale"
      (datesRender)="handleDatesRender($event)"
      (dateClick)="handleDateClick($event)"
    ></full-calendar>
  </div>
</div>